import { Loader } from 'braid-design-system';
import React from 'react';

export default function PricePanelLoader() {
  return (
    <div data-testid="pricepanel-loader">
      <Loader />
    </div>
  );
}
